const reducer = (accumulator, currentValue) => accumulator + currentValue
export default {
  sum: (array, action) => {
    if (array.length === 0) return 0
    return array.map(action).reduce(reducer)
  }
}
